import * as React from 'react';
import { UIHeading2 } from '@cian/ui-kit';

import * as style from './SimplePhone.css';

interface ISimplePhoneProps {
  phone: string;
}

export function SimplePhone({ phone }: ISimplePhoneProps) {
  return (
    <div className={style['container']}>
      <UIHeading2>{phone}</UIHeading2>
    </div>
  );
}
